import { useSelector } from "react-redux";
import Navbar from "./navbar";
import Sidebar from "./sidebar";
const Layout = ({ children }) => {
  const user = useSelector((state) => state.me.data);

  return (
    <div
      className={`min-h-screen flex ${
        user?.role == "admin" ? "flex-col md:flex-row gap-2" : "flex-col"
      } justify-start`}
    >
      {user?.role == "admin" ? <Sidebar user={user} /> : <Navbar />}

      <div className={`grow  ${user?.role == "admin" ? "md:w-3/4" : ""}  bg-[#f8f8f8] pb-40 pt-10`}>
        <div className="  px-4 mx-auto lg:max-w-7xl md:items-center    md:px-8">
          {children}
        </div>
      </div>
    </div>
  );
};
export default Layout;
